module.exports = __webpack_public_path__ + "img/logo-groupe-emc-inline.906bfc79.svg";